import React, { useContext } from "react"
import Layout from "../../components/layout"
import NullIf from "../../services/NullIf"

import ThemeContext from "../../context/ThemeContext"
import { graphql } from "gatsby"
import GenericLandingContentWrapper from "../../components/text-helpers/generic-landing-content-wrapper"
import SEO from "../../components/seo"
import MainSearch from "../../components/main-search/main-search"
import localize from "../../components/localize"

const Content = ({ bonuses, locale }) => {
  return (
    <div>
      <MainSearch locale={locale} bonuses={bonuses} />
    </div>
  )
}

const HasLiveCasino = ({ location, data, pageContext }) => {
  let site = useContext(ThemeContext)
  let { locale, alternateLocaleSlugs } = pageContext
  let bonuses = site.bonuses
  bonuses = bonuses
    .filter(x => NullIf.isNotNullOrEmpty(x))
    .filter(x => x.hasLiveCasino)

  const pageData = data.sanityGenericLandingPage

  return (
    <Layout breadcrumbNameOverride={pageData.breadcrumbName} pageContext={pageContext} location={location}>
      <SEO location={location}
         alternateSlug={alternateLocaleSlugs}
        title={pageData && pageData.seoTitle}
        description={pageData && pageData.seoMeta}
        bonuses={bonuses}
      />
      <GenericLandingContentWrapper pageData={pageData} headerClassName={`gambleGeneralWrapper`} bodyClassName={`gambleGeneralWrapper`}>
        <Content bonuses={bonuses} locale={locale} />
      </GenericLandingContentWrapper>
    </Layout>
  )
}

export default localize(HasLiveCasino)
export const pageQuery = graphql`
  query LiveCasinosLanding {
    sanityGenericLandingPage(
      name: { eq: "Live Casinos" }
    ) {
      ...GenericLanding
    }
  }
`
